import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import SubscriptionWrapper from './SubscriptionWrapper';  

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SubscriptionWrapper />  {/* ← CHANGED */}
  </React.StrictMode>
);


// Register service worker for offline functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}